module.exports = __webpack_public_path__ + "img/inner_5_bg.d01a7f7c.png";